module.exports = __webpack_public_path__ + "img/undraw_things_to_say_re_jpcg.2575c252.svg";